/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Create_FirstInputs */

const en_us2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Workout A`)
};

const pt_br2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Treino A`)
};

const es_419_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear Entrenamiento A`)
};

const pt_pt2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Treino A`)
};

const fr_fr2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer la séance A`)
};

const de_de2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training A erstellen`)
};

const it_it2_plan_build_create_first = /** @type {(inputs: Plan_Build_Create_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Allenamento A`)
};

/**
* | output |
* | --- |
* | "Create Workout A" |
*
* @param {Plan_Build_Create_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_create_first = /** @type {((inputs?: Plan_Build_Create_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Create_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_create_first(inputs)
	if (locale === "es-419") return es_419_plan_build_create_first(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_create_first(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_create_first(inputs)
	if (locale === "de-DE") return de_de2_plan_build_create_first(inputs)
	if (locale === "it-IT") return it_it2_plan_build_create_first(inputs)
	return en_us2_plan_build_create_first(inputs)
});
export { plan_build_create_first as "plan-build.create_first" }